import { caseTaskSchema } from "@/components/Forms/schema/addCaseTasksSchema.ts";
import { clientSchema } from "@/components/Forms/schema/caseFormSchemaInput.ts";
import { savePersonOnCaseSchema } from "@/components/Forms/schema/personSchema.ts";
import { dayjsLocalDateSchema } from "@/utils/zod.ts";
import { z } from "zod";

export const caseFormSchema = z
    .object({
        id: z.string(),
        idUUID: z.string(),
        clientName: z.string().nullable(),
        caseName: z.string().nullable(),
        caseType: z.string().optional().nullable(),

        anteLitemState: z.string().nullable(),
        dOICounty: z.string().nullable(),
        dateOfIncident: dayjsLocalDateSchema.nullable(),
        statuteOfLimitations: dayjsLocalDateSchema.nullable(),

        anteLitemYesNo: z.string().nullable(),
        anteLitemGovernmentEntity: z.string().nullable(),
        anteLitem: dayjsLocalDateSchema.nullable(),
        anteLitemEntity: z.string().nullable(),

        idCaseStatus: z.string().nullable(),
        liabilityAccepted: z.string().nullable(),
        demandLiabilitySentOn: dayjsLocalDateSchema.nullable(),
        litigationStatus: z.string().nullable(),

        idCaseStatusUM: z.string().nullable(),
        uMUIMAccepted: z.string().nullable(),
        demandUMSentOn: dayjsLocalDateSchema.nullable(),
        erisaUMSentOn: dayjsLocalDateSchema.nullable(),
        litigationSubStatus: z.string().nullable(),

        assignedTeam: z.string().nullable(),
        assignedToAttorney: z.string().nullable(),
        assignedToDisbursementSpecialist: z.string().nullable(),
        assignedToIntakeSpecialist: z.string().nullable(),

        assignedToParalegal: z.string().nullable(),
        assignedToMedicalRecordsClerk: z.string().nullable(),

        financeLoan: z.string().nullable(),
        attorneyFee: z.string().nullable(),
        crmStatus: z.string().nullable(),

        // for conditional display
        idCaseStatusDisplayValue: z.string().optional().nullable(),

        // determined
        referralRadio: z.string().nullable(),

        // health insurance
        insidCompany: z.string().nullable().optional(),
        insMemberName: z.string().nullable().optional(),
        insMemberID: z.string().nullable().optional(),
        insPlanNumber: z.string().nullable().optional(),

        // accident info
        accidentReportDone: z.string().nullable().optional(),
        incidentReportDoneWho: z.string().nullable().optional(),
        accidentCaseNumber: z.string().nullable().optional(),
        pDSettled: z.string().nullable().optional(),
        pDSettledAmount: z.string().nullable().optional(),
        mainInjury1: z.string().nullable().optional(),
        mainInjury2: z.string().nullable().optional(),
        injury: z.string().optional().nullable(),
        clientPainScale: z.string().nullable().optional(),
        primaryStatute: z.string().nullable().optional(),
        accidentSummary: z.string().nullable().optional(),
        incidentLocation: z.string().nullable().optional(),
        medpayRequired: z.boolean().optional().nullable(),
        medpayAmount: z.string().optional().nullable(),
        medpayReceived: z.string().optional().nullable(),

        clientPIN: z.string().nullable().optional(),

        idReferredBy: z.string().nullable().optional(),
        idReferredByCompany: z.string().nullable().optional(),

        idPeople: savePersonOnCaseSchema.nullable(),
        idClient: clientSchema.nullable(),
        taskSchema: z.array(caseTaskSchema).optional(),

        // optional save with task
        caseTaskUUID: z.string().optional(),
        note: z.string().optional(),
        caseStatus: z.string().optional().nullable(),

        policyLimits: z.boolean().optional().nullable(),
        policyLimitsTimestamp: z.string().optional().nullable(),
    })
    .superRefine((data, ctx) => {
        if (
            data.medpayRequired === true &&
            (!data.medpayAmount ||
                data.medpayAmount.trim() === "" ||
                Number.parseFloat(data.medpayAmount) <= 0)
        ) {
            ctx.addIssue({
                path: ["medpayAmount"],
                code: z.ZodIssueCode.custom,
                message: "Medpay amount is required.",
            });
        }
    });

export const casesFilterSchema = z.object({
    idCaseStatus: z.string().nullable(),
    caseType: z.string().nullable(),
    caseStatus: z.string().nullable(),
    daysToSol: z.string().nullable(),
    liabilityAge: z.string().nullable(),
    umAge: z.string().nullable(),
});
